import styled from "styled-components";

const Card = styled.div.attrs({
  className:
    "bg-[#FFFFFF] w-[530px] flex flex-col justify-center items-center p-8 rounded-lg shadow-xl",
})``;

const CardContent = styled.div.attrs({
  className: "w-4/5 sm:w-3/4 md:w-1/2",
})``;

const CardTitle = styled.div.attrs({
  className: "text-[#DF6865] text-2xl font-bold self-start",
})``;


const Form = styled.div.attrs({
  className: "text-[#444444] w-full flex flex-col justify-center items-center",
})``;


export default {
  Card,
  CardContent,
  CardTitle,
  Form
};
